import { search_asp, has_row, has_column, trimFieldString } from "../util.js";

export function translateTranspose(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  rules.push({
    category: "recommender",
    description: `Transpose axes`,
    specifier: { "role": "view" },
    action: "transpose"
  })
  let y_reversred = false;
  // orientation adjustment for nominal charts
  if (source?.layout?.column !== undefined && source?.layout?.composition === "single") {
    let newXfield = source.layout?.row?.[source.layout.row?.length - 1];
    let newYfield = source.layout?.column?.[source.layout.column?.length - 1];
    if (newXfield && newYfield) {
      if (newYfield.constructor.name === "Array") newYfield = newYfield[0];
      newYfield = newYfield.field || newYfield;
      if (search_asp(parsed, "do(reverse_cont_scale_after_transpose)").length > 0) {
        rules.push({
          category: "recommender",
          description: `Reverse row for ${newYfield}`,
          specifier: {
            role: "view.row",
            field: newYfield
          },
          action: "modify",
          option: {
            sort: { reverse: true }
          }
        });
        y_reversred = true;
      } else if (search_asp(parsed, "do(reverse_temporal_scale_after_transpose", "startsWith").length > 0) {
        rules.push({
          category: "recommender",
          description: `Reverse row for ${newYfield}`,
          specifier: {
            role: "view.row",
            field: newYfield
          },
          action: "modify",
          option: {
            sort: { reverse: true }
          }
        });
        y_reversred = true;
      }
    }
  }
  // axis/mark label adjustment
  source.layer.forEach((layer, li) => {
    let layer_specifier = {};
    if (layer.name) layer_specifier.id = layer.name;
    else layer_specifier.index = li;
    layer.text?.forEach(text_elem => {
      if (text_elem.type === "on-axis" && has_row(source, text_elem.field)) {
        let field_cardinality = source.datatype?.[text_elem.field]?.cardinality;
        let field_type = source.datatype?.[text_elem.field]?.type;
        let to_top = search_asp(parsed, "do(orient_x_bottom_to_top)").length == 1
        if (to_top) {
          rules.push({
            category: "recommender",
            description: `Reposition axis label for ${text_elem.field}`,
            specifier: { role: "axis", field: text_elem.field },
            action: "reposition",
            option: {
              orient: "bottom",
              offset: 5
            }
          });
          if (text_elem.items?.length <= 1 && to_top) {
            rules.push({
              category: "recommender",
              description: `Modify alignment of axis label for ${text_elem.field}`,
              specifier: { role: "axis.label", field: text_elem.field, layer: layer_specifier },
              action: "modify",
              option: {
                textAlign: "center"
              }
            });
          }
        }

        let p;
        if ((p = search_asp(parsed, "do(rotate_line_mark_label,", "startsWith")[0], p !== undefined)) {
          let layer = source.layer[mapping[p.args[1]].layer];
          let text = layer?.text[mapping[p.args[2]].text];
          let field = trimFieldString(p.args[3]);
          if (layer && text) {
            let rotate_rule = {
              category: "recommender",
              description: `Rotate mark label for ${field}`,
              specifier: { role: "mark.label", field, layer: layer_specifier },
              action: "modify",
              option: {
                "angle": y_reversred ? 45 : -45
              }
            };
            if (text.name) rotate_rule.specifier.id = text.name;
            else rotate_rule.specifier.index = mapping[p.args[2]].text;
            if (layer.name) rotate_rule.specifier.layer = { id: layer.name }
            else if (layer.mark?.type) rotate_rule.specifier.mark = layer.mark.type;
            else rotate_rule.specifier.layer = { index: mapping[p.args[1]].layer };
            rules.push(rotate_rule);
          }
        }

      } else if (text_elem.type === "on-axis" && has_column(source, text_elem.field)) {
        let field_cardinality = source.datatype?.[text_elem.field]?.cardinality;
        let field_type = source.datatype?.[text_elem.field]?.type;
        let rule = {
          category: "recommender",
          description: `Reposition axis label for ${text_elem.field}`,
          specifier: { role: "axis", field: text_elem.field },
          action: "reposition",
          option: {
            orient: "bottom"
          }
        };
        if (field_cardinality < 5 && ["nominal", "ordinal"].includes(field_type)) {
          rule.option.orient = "top";
          rules.push(rule);
          rules.push({
            category: "recommender",
            description: `Unwrap axis label for ${text_elem.field}`,
            specifier: { role: "axis.label", field: text_elem.field, layer: layer_specifier },
            action: "modify",
            option: {
              "width": null
            }
          });
        }
      } else if (text_elem.type === "on-mark" && search_asp(parsed, 'detect(mark_orient,horizontal)').length >= 1) {
        let reversed = search_asp(parsed, 'do(reverse_cont_scale_after_transpose)').length > 0
        let rule = {
          category: "recommender",
          description: `Reposition mark label for ${text_elem.field}`,
          specifier: { role: "mark.label", field: text_elem.field, layer: layer_specifier },
          action: "modify",
          option: {
            "orient": (reversed ? "bottom-center" : "top-center"),
            "anchor": "middle",
            "textAlign": "center"
          }
        };
        if (text_elem.dx !== undefined) {
          rule.option.dx = null;
          rule.option.dy = -1 * Math.sign(text_elem.dx) * 5;
        }
        rules.push(rule);
      } else if (text_elem.type === "on-mark" && search_asp(parsed, 'detect(mark_orient,vertical)').length >= 1) {
        let rule = {
          category: "recommender",
          description: `Reposition mark label for ${text_elem.field}`,
          specifier: { role: "mark.label", field: text_elem.field, layer: layer_specifier },
          action: "modify",
          option: {
            "orient": "middle-right",
            "anchor": "start",
            "textAlign": "left"
          }
        };
        if (text_elem.dy !== undefined) {
          rule.option.dy = null;
          rule.option.dx = - text_elem.dy;
        }
        rules.push(rule);
      }
      // label dx, dy
      if (text_elem.type === "on-axis") {
        if (text_elem.dx || text_elem.dy) {
          let dx = text_elem.dy || null,
            dy = text_elem.dx || null;
          if (dx !== null && dx.constructor.name === "Number") dx = dx * -1;
          else if (dx !== null && dx.constructor.name === "String") dx = dx.startsWith("-") ? dx.replace("-", "") : "-" + dx;
          if (dy !== null && dy.constructor.name === "Number") dy = dy * -1;
          else if (dy !== null && dy.constructor.name === "String") dy = dy.startsWith("-") ? dy.replace("-", "") : "-" + dy;
          let rule_dx_dy = {
            category: "recommender",
            description: `Reposition axis label for ${text_elem.field}`,
            specifier: { role: "axis.label", field: text_elem.field },
            action: "modify",
            option: {
              dx,
              dy
            }
          };
          if (text_elem.type === "on-axis" && text_elem.orient) {
            rule_dx_dy.option.orient = text_elem.orient;
          }
          rules.push(rule_dx_dy)
        }
      }
    })
  });
  // axis assist reposition
  source.annotation?.items?.forEach((anno, ni) => {
    // let anno = source?.annotation?.items[mapping[p.args[0]].annotation];
    let old_x = anno.x, old_y = anno.y;
    // static
    if (anno.axisAssist && config.has_old_new_size) {
      let rule_reposition = {
        category: "recommender",
        description: `Reposition annotation for ${anno.name || ""}`,
        specifier: {
          "role": "annotation"
        },
        action: "reposition",
        option: {
        }
      }
      if ("name" in anno) {
        rule_reposition.specifier.id = anno.name;
      }
      else {
        rule_reposition.specifier.index = ni;
      }
      // positioning
      let new_x = scalePositionTransition(old_y, config.new_size[0] / config.old_size[1]);
      if (new_x.endsWith("%")) new_x = (100 - parseFloat(new_x)) + "%";
      let new_y = scalePositionTransition(old_x, config.new_size[1] / config.old_size[0]);
      rule_reposition.option.x = new_x;
      rule_reposition.option.y = new_y;

      // axis assist adjust
      if (anno.axisAssist) {
        // axis assist rotate
        if (anno.angle == undefined) {
          // horizontal annotation
          rule_reposition.option.rotate = "90deg";
        } else if (anno.angle == '90deg') {
          // vertical annotation
          rule_reposition.option.rotate = null;
        }
      }
      rules.push(rule_reposition);
    }
  });
  // stack mode change
  let stackModeChange = search_asp(parsed, "do(change_stack_mode", "startsWith")[0];
  if (stackModeChange) {
    // do(change_stack_mode,RC,I,default)
    let rc = stackModeChange.args[1];
    let rci = parseInt(mapping[stackModeChange.args[2]]['layout.' + rc]);
    let rc_elem = source.layout[rc][rci]
    let rule_stack = {
      category: "recommender",
      description: `Change the stack mode`,
      specifier: { "role": "view." + rc, index: rci },
      action: "modify",
      option: {
        stack: stackModeChange.args[3]
      }
    }
    if (rc_elem?.field) {
      rule_stack.specifier.field = rc_elem.field;
    }
    rules.splice(0, 0, rule_stack);
  }
  return rules;
}

function scalePositionTransition(value, scale) {
  if (value.constructor.name === "String" && value.endsWith("%")) {
    return value;
  } else if (value.constructor.name === "Number") {
    return Math.round(value * scale);
  } else if (value.constructor.name === "String") {
    let unit;
    if (value.endsWith("px")) unit = "px";
    else if (value.endsWith("em")) unit = "em";
    else if (value.endsWith("rem")) unit = "rem";
    else if (value.endsWith("in")) unit = "in";
    else if (value.endsWith("cm")) unit = "cm";
    else if (value.endsWith("mm")) unit = "mm";
    if (unit) {
      return (Math.round(parseFloat(value) * scale)) + unit;
    } else {
      return null;
    }
  }
}

export function addTransposeAdjustment(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  let transposed = search_asp(parsed, "do(transpose)").length == 1;
  source.layout?.row?.forEach(row => {
    if (row.field !== undefined && row.scale?.range !== undefined) {
      let old_max = Math.max(...row.scale.range), old_h = config.old_size[1], new_h = config.new_size[(transposed ? 0 : 1)];
      let new_max = old_max * new_h / old_h;
      let new_range = row.scale.range.map(d => d / old_max * new_max);
      rules.push({
        category: "recommender",
        description: `Modify row scale for ${row.field}`,
        specifier: { role: "view.row", field: row.field },
        action: "modify",
        option: { scale: { range: new_range } }
      });
    }
  });

  source.layout?.column?.forEach(column => {
    if (column.field !== undefined && column.scale?.range !== undefined) {
      let old_max = Math.max(...column.scale.range), old_w = config.old_size[0], new_w = config.new_size[(transposed ? 1 : 0)];
      let new_max = old_max * new_w / old_w;
      let new_range = column.scale.range.map(d => d / old_max * new_max);
      rules.push({
        category: "recommender",
        description: `Modify column scale for ${column.field}`,
        specifier: { role: "view.column", field: column.field },
        action: "modify",
        option: { scale: { range: new_range } }
      });
    }
  });
  return rules;
}
